var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M 9.93 5.28 C 9.75 5.78 9.61 6.37 9.51 7 M 9.51 7 C 9.381 7.857 9.314 8.723 9.31 9.59 M 9.51 7 L 11.75 7 M 9.51 7 L 7.48 7 M 9.3 9.59 C 9.3 11.07 9.44 12.51 9.7 13.49 M 9.3 9.59 C 5.81 10.09 6 13.54 9.2 13.54 C 9.37 13.54 9.54 13.52 9.7 13.48 M 9.3 9.58 C 9.58 9.55 9.87 9.53 10.19 9.53 C 11.09 9.53 11.89 9.74 12.51 10.13 M 9.71 13.48 C 9.77 13.72 9.84 13.93 9.91 14.11 M 9.71 13.48 C 11.36 13.15 12.51 11.26 12.51 10.12 M 12.51 10.12 C 13.269 10.539 13.746 11.333 13.76 12.2 M 12.51 10.12 C 12.64 9.45 12.64 8.95 12.64 8.95 M 13.47 17.96 L 14.24 16.37 M 14.24 16.37 L 18.87 16.37 M 14.24 16.37 L 16.56 11.61 L 18.87 16.38 M 18.87 16.38 L 19.65 17.96 M 17 2 L 9 2 C 5 2 3 4 3 8 L 3 15.1 L 1.07 19.13 C 0.429 20.458 1.395 21.999 2.87 22 L 17 22 C 20.98 22 23 20 23 16 L 23 8 C 23 4.13 21 2 17 2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.356b9325e76878025bebbdbd1a4bec3c.svg";
export { ForwardRef as ReactComponent };